define('superAdminMbAnaResDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!superAdminMbAnaResDetailsTpl',
  'superAdminMbAnaResTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  mbAnaResTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var MbAnaResDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.mbanares-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      name: '.p-name',
      code: '.p-code'
    },

    regions: {
      mbAnaResDetailTab: '#detail-tab'
    },

    behaviors: function() {
      var redirectUrl = 'superAdmin/mbanaresgrs/'+ this.options.model.get('mbAnaResGrSecId');
      return {
        BackToList: {
          behaviorClass: BackToListBehavior,
          redirectUrl: redirectUrl
        }
      };
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.mbAnaResTabs = mbAnaResTabs;
      templateData.compulogoCollection = this.model.get('compulogoCollection');
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.mbanares-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    }
  });

  module.exports = MbAnaResDetailsView;
});
